const ROUTE_LABELS = {
  dashboard: "Panel",
  tables: "Metas",
  billing: "Administración",
  whatsapp: "WhatsApp",
  profile: "Perfil",
  special: "Registros del día",
  authentication: "Acceso",
  "sign-in": "Iniciar sesión",
};

export function getRouteLabel(segment) {
  if (!segment) return "";
  return ROUTE_LABELS[segment] || segment.replace(/-/g, " ");
}

export function getPageTitle(routeSegments) {
  if (!routeSegments?.length) return "Inicio";
  const last = routeSegments[routeSegments.length - 1];
  return getRouteLabel(last);
}
